import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { DefaultLayoutDirective } from '../../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../../flex-layout/flex';
import { MatIconButton } from '@angular/material/button';
import { DefaultLayoutAlignDirective } from '../../../../flex-layout/custom-layout-align';
import { environment } from '../../../../../environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { CartService } from '../../../../services/cart.service';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../../../../services/user.service';
import { CalsoftService } from '../../../../services/calsoft.service';
import { Constant } from '../../../../../constants/constant';
import { CommonSignInComponent } from '../../../../shared/common-sign-in/common-sign-in.component';
import { CategoryService } from '../../../../services/category.service';
import { Location } from '@angular/common';
import { SideBarMenuPopupComponent } from '../../menu/menu/side-bar-menu/side-bar-menu-popup/side-bar-menu-popup.component';
import { filter } from 'rxjs';

@Component({
  selector: 'calsoft-mobile-header9',
  imports: [MatToolbar, MatToolbarRow, DefaultLayoutDirective, DefaultFlexDirective, MatIconButton, DefaultLayoutAlignDirective],
  templateUrl: './mobile-header9.component.html',
  styleUrl: './mobile-header9.component.scss'
})
export class MobileHeader9Component implements OnInit {

  @Input() item: any;
  @Input() url: any;
  @Input() userLoggedIn: any;
  @Input() color: any;
  categoryArray: any = [];
  referer: string | any;

  //logoPositionMobile:boolean = false;
  mobileHeaderHeight: any;
  mobileHeaderLogoGap: any;
  layout: any = 0;
  headerIconColour: any;
  @Input() data: any;
  showMenu: boolean | any;


  public serverPath = environment.commonImageApi + "logo/";

  public serverPath3 = environment.commonImageApi + "mobileImage/";

  mobileLogoSrc: any;

  mobileLogoEnable: any = 0;
  disableCartIconInHeader: any = 0;

  disableLoginHeader: any = 0;
  disableWishlistHeader: any = 0;
  contentDiv: boolean;
  constructor(
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    public cartServices: CartService,
    private dialog: MatDialog,
    private userService: UserService,
    private categoryService: CategoryService,
    private location: Location,
    public calsoftService: CalsoftService,) {
    this.contentDiv = false;
  }

  display: boolean = false;
  hidePage: boolean = false;
  ngOnInit(): void {

    this.checkCurrentRoute();
    this.setupRouteListener();
    this.userLogged();
    this.setDisplayBasedOnScreenSize();
    this.url = this.router.url;

    if (window.innerWidth < 1281) {
      this.display = false;
    } else {
      this.display = true
    }

    this.getCategories();
    this.referer = Constant.REFERER;

    if (this.data != undefined) {
      if (this.data['logoPositionMobile'] != undefined) {
        this.layout = this.data['logoPositionMobile'];
      }

      if (this.data['headerIconColour'] != undefined) {
        this.headerIconColour = this.data['headerIconColour'];
      }

      if (this.data['mobileLogoSrc'] != undefined) {
        this.mobileLogoSrc = this.data['mobileLogoSrc'];
      }

      if (this.data['mobileLogoEnable'] != undefined) {
        this.mobileLogoEnable = this.data['mobileLogoEnable'];
      }

      if (this.data['mobileHeaderHeight'] != undefined) {
        this.mobileHeaderHeight = this.data['mobileHeaderHeight'];
      }


      if (this.data['mobileHeaderLogoGap'] != undefined) {
        this.mobileHeaderLogoGap = this.data['mobileHeaderLogoGap'];
      }


      if (this.data['disableCartIconInHeader'] != undefined) {
        this.disableCartIconInHeader = this.data['disableCartIconInHeader'];
      }


      if (this.data['disableLoginHeader'] != undefined) {
        this.disableLoginHeader = this.data['disableLoginHeader'];
      }

      if (this.data['disableWishlistHeader'] != undefined) {
        this.disableWishlistHeader = this.data['disableWishlistHeader'];
      }



    }



    this.userLogged();

  }

  private setDisplayBasedOnScreenSize() {
    this.display = window.innerWidth >= 1281;
  }

  private setupRouteListener() {
    this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects || event.url;
        this.updateMenuVisibility(url);
        this.checkPageVisibility();
        this.changeDetector.detectChanges(); // Force change detection
      });
  }
  lastScrollPosition = 0;
  showMobileHeader = true;
  mobileScrollThreshold = 50; // Adjust as needed
  hideThreshold = 100; // Hide when scrolled beyond this point
  lastTouchY: number | undefined;

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    // Calculate scroll direction
    const scrollDelta = currentScrollPosition - this.lastScrollPosition;
    const scrollingDown = scrollDelta > 0;
    const scrollingUp = scrollDelta < 0;

    // Always show at top of page
    if (currentScrollPosition <= 50) {
      this.showMobileHeader = true;
    }
    // Show when scrolling up significantly
    else if (scrollingUp && Math.abs(scrollDelta) > 10) {
      this.showMobileHeader = true;
    }
    // Hide when scrolling down past threshold
    else if (scrollingDown && currentScrollPosition > this.hideThreshold) {
      this.showMobileHeader = false;
    }

    this.lastScrollPosition = currentScrollPosition;
  }


  private checkPageVisibility() {
    this.url = this.router.url;
    this.hidePage = this.url === '/blog' ||
      this.url.startsWith('/blog/') ||
      this.url.includes('/product/');
  }
  private checkCurrentRoute() {
    const currentUrl = this.router.url;
    this.updateMenuVisibility(currentUrl);
  }

  private updateMenuVisibility(url: string) {
    this.showMenu = !(url.includes('/crm-solution') || url.includes('/crm-solution-thank-you') || url.includes('/calsoft-crm'));
  }
  page1: any;
  public toggleSidebarz() {
    // this.calsoftService.sidenavOpen = !this.calsoftService.sidenavOpen;
    this.contentDiv = !this.contentDiv;
  }
  gotoHome() {
    if (this.router.url != '/home') {
      this.router.navigate(['/']);
    }
  }

  cart() {
    let basicAuthHeaderString = this.userService.getAuthenticatedToken();
    let username = this.userService.getAuthenticatedUser();

    if (basicAuthHeaderString && username) {
      this.router.navigate(['/cart'])

    }
    else {
      this.page1 = "cart";
      this.loginModel();

      // this.router.navigate(['/cart'])

    }

  }


  loginModel() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CommonSignInComponent, {
        width: '790px',
        data: { page: this.page1, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();


      });

    }
    else {
      let dialogRef = this.dialog.open(CommonSignInComponent, {
        minWidth: '100vw', height: '100vh',
        data: { page: this.page1, }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        this.ngOnInit();


      });
    }

  }
  back() {

    if (this.router.url.includes('/order/')) {
      this.router.navigate(['/orders'])
    } else {
      // this.router.navigate(['/'])
      this.location.back();
    }

  }


  SignIn() {
    // this.router.navigate(['/sign-in']);
    this.loginModel();
  }


  userLogged() {

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    let basicAuthHeaderString = this.userService.getAuthenticatedToken();
    let username = this.userService.getAuthenticatedUser();

    if (basicAuthHeaderString && username) {

      this.userLoggedIn = true;
      this.cartServices.getCount();

    }
    else {

      this.userLoggedIn = false;
    }
  }


  navigateTo(route: string) {
    this.router.navigate([route]);
  }


  getCategories() {
    this.categoryService.categoryList().subscribe(
      result => {
        this.categoryArray = result['data'];
      },
      error => {
      }
    )
  }

  toggleSidebar() {
    let dialogRef = this.dialog.open(SideBarMenuPopupComponent, {
      minWidth: '100vw', height: '100vh',
      backdropClass: 'no-backdrop',
      panelClass: 'custom-dialog',
      data: { data: this.categoryArray, datas: this.data },
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

}

